export default ({ request }) => ({

  shipmentBookingListApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/list',
      method: 'post',
      data,
    })
  },
  shipmentBookingDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/detail',
      method: 'post',
      data,
    })
  },
  shipmentBookingSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/save',
      method: 'post',
      data,
    })
  },
  shipmentBookingDelApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/del',
      method: 'post',
      data,
    })
  },
  shipmentBookingUpdateNoApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/updateNo',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerListApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/container/list',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/container/save',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerEditApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/container/edit',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerDelApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/container/del',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerBookingSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/container/booking/save',
      method: 'post',
      data,
    })
  },
  shipmentBookingChooseContainerListApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/choose/container/list',
      method: 'post',
      data,
    })
  },
  shipmentBookingListByPortApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/listByPort',
      method: 'post',
      data,
    })
  },
  shipmentBookingContainerPoListApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/containerPoList',
      method: 'post',
      data,
    })
  },
  shipmentBookingBatchEditApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/batchEdit',
      method: 'post',
      data,
    })
  },
  shipmentBookingUpdateConsigneeApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/updateConsignee',
      method: 'post',
      data,
    })
  },
  shipmentBookingUpdatePoOneApi(data = {}) {
    return request({
      url: '/factory/shipmentBooking/updatePoOne',
      method: 'post',
      data,
    })
  },
})
